import { SymbolicTeamForm } from 'modules/championship/ui/components/symbolic-team-form';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SymbolicTeam } from 'modules/championship/domain/interfaces/symbolic-team';
import { selectSymbolicTeam, showChampionshipSymbolicTeamForm } from 'modules/championship/store/championship/actions';
import {
  championshipSymbolicTeamFormShownSelector,
  championshipSymbolicTeamSelectedSelector,
} from 'modules/championship/store/championship/selectors';
import { useAcceptedChampionshipTeams } from 'modules/championship/ui/hooks/use-accepted-championship-teams';
import { SymbolicTeamsGrid } from './symbolic-teams-grid';

type ChampionshipSymbolicTeamsProps = {
  championshipId: number;
  items: SymbolicTeam[];
};

const ChampionshipSymbolicTeams = ({ championshipId, items }: ChampionshipSymbolicTeamsProps) => {
  const dispatch = useDispatch();
  const selectedSymbolicTeam = useSelector(championshipSymbolicTeamSelectedSelector(championshipId));
  const { teams: allTeams } = useAcceptedChampionshipTeams(championshipId);
  // Форма открыта или нет — в сторе, а не в локальном состоянии: по этому флагу
  // вкладка «Сборные» показывает подпись и умеет вернуть к списку, как на этапах.
  const showForm = useSelector(championshipSymbolicTeamFormShownSelector(championshipId));

  const handleSelectTeam = useCallback(
    (team: SymbolicTeam | null) => {
      dispatch(selectSymbolicTeam({ symbolicTeam: team, championshipId }));
      dispatch(showChampionshipSymbolicTeamForm({ state: true, championshipId }));
    },
    [dispatch, championshipId],
  );

  if (!showForm) {
    return (
      <div className="w-full px-6">
        <SymbolicTeamsGrid items={items} onSelect={handleSelectTeam} />
      </div>
    );
  }

  return (
    <div className="w-full px-6">
      <SymbolicTeamForm championshipId={championshipId} allTeams={allTeams!} symbolicTeam={selectedSymbolicTeam} />
    </div>
  );
};

export default ChampionshipSymbolicTeams;
